import { Fire } from "@phosphor-icons/react";
import clsx from "clsx";

import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";

import useAccountLimits from "../../datahooks/useAccountLimits";

export default function WarmupState({
  accountId,
  isTag,
}: {
  accountId: string;
  isTag: boolean;
}) {
  const { accountLimits, isLoadingAccountLimits } = useAccountLimits(accountId);

  if (isLoadingAccountLimits || !accountLimits) {
    return (
      <Skeleton
        className={clsx("rounded-md", isTag ? "h-4 w-16" : "h-5 w-14")}
      />
    );
  }
  const textValue = accountLimits.warmup.enabled ? "On" : "Off";

  if (isTag) {
    return (
      <Tag variant="tertiary" leftIcon={<Fire weight="fill" />} size="sm">
        {textValue}
      </Tag>
    );
  }
  return <span className="text-button-xs">{textValue}</span>;
}
